import FormInput from '../../components/FormInput'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Fragment from '../../components/Fragment'
import { FORMS } from '../../constants'
import { formValidation } from '../../helpers'
import { camelizeKeys } from 'humps'

export default ({ user, fragments, onSubmit }) => {
  const dispatch = useDispatch()
  const act = useAct()
  const formRefs = _.mapValues(FORMS.donationSignup.fields, () => useRef())
  const [formData, setFormData] = useState(
    Object.assign(FORMS.donationSignup.fields, user)
  )
  const [formErrors, setFormErrors] = useState(
    _.mapValues(FORMS.donationSignup.fields, () => null)
  )
  const [disabled, setDisabled] = useState(false)

  const updateForm = (prop, evt) => {
    setFormErrors(_.mapValues(FORMS.donationSignup.fields, () => null))
    setFormData({ ...formData, [prop]: evt.target.value })
  }

  const updateConsent = (evt) => {
    setFormData({ ...formData, opt_in: evt.target.checked })
  }

  const doSignup = useSelector((state) => state.local.doSignup)

  useEffect(() => {
    if (doSignup) {
      const signupSuccess = submitSignup()
      dispatch({
        type: 'local/upsert',
        payload: { doSignup: false, signupSuccess },
      })
    }
  }, [doSignup])

  const submitSignup = () => {
    setDisabled(true)
    const res = formValidation(formRefs, formErrors)
    if (res.valid) {
      onSubmit(formData)
      axios
        .post('api/signup', { signup: formData })
        .then(() =>
          act.donation.upsert(
            _.pick(camelizeKeys(formData), ['email', 'firstName', 'lastName', 'optIn'])
          )
        )
      return true
    } else {
      setFormErrors(res.errors)
      setDisabled(false)
      dispatch({
        type: 'local/upsert',
        payload: { signupValidation: true },
      })
      return false
    }
  }

  const fParams = {
    onChange: updateForm,
    formData,
    formErrors,
    formRefs,
    disabled,
    required: true,
  }

  return (
    <Grid item container spacing={3} component="form">
      <Grid item xs={12} sm={6}>
        <FormInput {...fParams} fieldName="first_name" />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput {...fParams} fieldName="last_name" />
      </Grid>
      <Grid item xs={12}>
        <FormInput {...fParams} fieldName="email" />
      </Grid>
      <Grid item xs={12}>
        <Fragment title="above_donation_signup_consent" {...{ fragments }} />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox checked={formData.opt_in} onChange={(e) => updateConsent(e)} />
          }
          label={<Fragment title="donation_signup_consent" {...{ fragments }} />}
        />
      </Grid>
    </Grid>
  )
}
